import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect, } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { IGrupo, IDeleteGrupoResponse, IUpdateGrupoResponse } from '../../interfaces/grupos.interface';
import {
  AddIntegranteGrupo, AddIntegranteGrupoSuccess,
  CreateAsistencias,
  CreateAsistenciasSuccess,
  CreateGrupo, CreateGrupoSuccess, DeleteGrupo, DeleteGrupoSuccess,
  DeleteIntegranteGrupo, DeleteIntegranteGrupoSuccess,
  GetAsistencias,
  GetAsistenciasSuccess,
  GetGrupos, GetGruposSuccess, GetSesiones, GetSesionesSuccess, UpdateGrupo, UpdateGrupoSuccess
} from '../actions/grupos.actions';

@Injectable()
export class GruposEffects {
  getGrupos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetGrupos),
      switchMap(() =>
        this.apiService.getGrupos().pipe(
          map((grupos: IGrupo[]) => GetGruposSuccess({ grupos }))
        )
      )
    )
  );

  createGrupo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateGrupo),
      switchMap(payload =>
        this.apiService.createGrupo(payload.grupo).pipe(
          map((grupo: IGrupo) => CreateGrupoSuccess({ grupo }))
        )
      )
    )
  );

  deleteGrupo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteGrupo),
      switchMap(payload =>
        this.apiService.deleteGrupo(payload.id).pipe(
          map((grupo: IDeleteGrupoResponse) => DeleteGrupoSuccess({ grupo }))
        )
      )
    )
  );

  updateGrupo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateGrupo),
      switchMap(payload =>
        this.apiService.updateGrupo(payload.id, payload.grupo).pipe(
          map((grupo: IUpdateGrupoResponse) => UpdateGrupoSuccess({ grupo }))
        )
      )
    )
  );

  addIntegrante$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddIntegranteGrupo),
      switchMap(payload =>
        this.apiService.addIntegranteGrupo(payload.id, payload.integrante).pipe(
          map((integrante: IGrupo) => AddIntegranteGrupoSuccess({ integrante }))
        )
      )
    )
  );

  deleteIntegrante$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteIntegranteGrupo),
      switchMap(payload =>
        this.apiService.deleteIntegranteGrupo(payload.id, payload.integrante).pipe(
          map((integrante: IGrupo) => DeleteIntegranteGrupoSuccess({ integrante }))
        )
      )
    )
  );

  getSesiones$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetSesiones),
            switchMap(payload =>
                this.apiService.getSesiones(payload.id).pipe(
                    map((sesiones: any[]) => GetSesionesSuccess({ sesiones }))
                )
            )
        )
    );

  getAsistencias$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetAsistencias),
            switchMap(payload =>
                this.apiService.getAsistencias(payload.id).pipe(
                    map((asistencias: any[]) => GetAsistenciasSuccess({ asistencias }))
                )
            )
        )
    );

    createAsistencias$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CreateAsistencias),
            switchMap(payload =>
                this.apiService.createAsistencias(payload.asistencias).pipe(
                    map((asistencias: any) => CreateAsistenciasSuccess({ asistencias }))
                )
            )
        )
    );

  constructor(
    private apiService: ApiService,
    private actions$: Actions,
    private store: Store<IAppState>
  ) { }
}
